import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import Card from "./Card"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import * as styles from "src/styles/video_card.module.scss"
import ResponsiveLinkedButton from "../buttons/ResponsiveLinkedButton"
import Spacer from "../Spacer"

export default function VideoCard({
  id,
  title,
  link,
  description,
  exercises,
  codeFiles,
  solutions,
  thumbnail,
}) {
  const data = useStaticQuery(graphql`
    query video_card {
      thumbnail: file(
        relativePath: { eq: "thumbnails/programming/Thumbnail.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `)

  return (
    <div className={styles.card}>
      <Link to={link} target="_blank">
        <Card>
          <div className={styles.video_card}>
            <GatsbyImage
              className={styles.thumbnail}
              image={getImage(data.thumbnail)}
              alt="Call"
            />
            <div className={styles.details}>
              {title && <h2 className={styles.title}>{title}</h2>}
              {description ? (
                <p className={styles.description}>{description}</p>
              ) : (
                <Spacer />
              )}
              <Spacer />
              {exercises && (
                <ResponsiveLinkedButton
                  path={exercises}
                  label="View Exercises"
                />
              )}
              {codeFiles && (
                <ResponsiveLinkedButton
                  path={codeFiles}
                  label="View Code Files"
                />
              )}
              {solutions && (
                <ResponsiveLinkedButton
                  path={solutions}
                  label="View Solutions"
                />
              )}
            </div>
          </div>
        </Card>
      </Link>
    </div>
  )
}
